import { _ROLES_BACK } from "../../utils/constants";
import {
  CellSelectionModule,
  ExcelExportModule,
  RowGroupingModule,
  ClipboardModule,
  ColumnMenuModule,
  ContextMenuModule,
} from "ag-grid-enterprise";
import {
  AllCommunityModule,
  ModuleRegistry,
  ClientSideRowModelModule,
  NumberEditorModule,
  TextEditorModule,
  ValidationModule,
} from "ag-grid-community";
import TableInputRateIncrease from "../../components/budget/inputRateIncrease/TableInputRateIncrease";
import { BaseBudgetInput } from "../../components/budget/BaseBudgetInput";
import ColumnBuilder from "../../components/budget/inputRateIncrease/ColumnBuilder";

ModuleRegistry.registerModules([
  ClientSideRowModelModule,
  AllCommunityModule,
  ExcelExportModule,
  RowGroupingModule,
  CellSelectionModule,
  TextEditorModule,
  ClipboardModule,
  ColumnMenuModule,
  NumberEditorModule,
  ValidationModule,
  ContextMenuModule,
]);

const InputRateIncrease = () => {
  return (
    <BaseBudgetInput
      title="Input Rate Increase"
      roles={[_ROLES_BACK._ROLE_ADMIN, _ROLES_BACK._ROLE_CTRL]}
      userRole={null}
      TableComponent={TableInputRateIncrease}
      ColumnBuilder={ColumnBuilder}
    />
  );
};

export default InputRateIncrease;
